import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"

import { useFormStore } from "components/forms/ArchitektAufAnfrage/formStore"
import StepLayout from "components/forms/ArchitektAufAnfrage/StepLayout"

import Button from "components/Button"
import RadioField from "components/forms/fields/Radio"
import TextField from "components/forms/fields/Text"
import TextareaField from "components/forms/fields/Textarea"
import SelectField from "components/forms/fields/Select"
import FileField from "components/forms/fields/File"
import ContentField from "components/forms/fields/Content"
import BookingDateField from "../../fields/BookingDate"
import CheckboxField from "components/forms/fields/Checkbox"
import BookingTimeField from "../../fields/BookingTime"
import BookingEmployeeField from "../../fields/BookingEmployee"
import BookingTypeField from "../../fields/BookingType"

const FIELDS = {
  radio: RadioField,
  text: TextField,
  select: SelectField,
  file: FileField,
  check: CheckboxField,
  booking_employee: BookingEmployeeField,
  booking_type: BookingTypeField,
  booking_date: BookingDateField,
  booking_time: BookingTimeField,
  content: ContentField,
  textarea: TextareaField,
}
const QuestionStep = ({}) => {
  const { getStep, prevStep, nextStep, data, setData } = useFormStore(
    (state) => ({
      getStep: state.getStep,
      prevStep: state.prevStep,
      nextStep: state.nextStep,
      data: state.data,
      setData: state.setData,
    })
  )

  const step = getStep()

  const methods = useForm({
    defaultValues: data,
    resolver: zodResolver(step.validation_schema),
  })

  const handleNext = () => {
    const formData = methods.getValues()
    const uniqueKeys = [...new Set(step.fields.map((field) => field.name))]
    uniqueKeys.forEach((key) => setData(key, formData[key]))
    nextStep()
    
    document.querySelector('.mainLayout').scrollTop = 0;
  }

  const handlePrev = () => {
    if (step.id === 2) {
      //Reset booked_type field as it may be unavailable
      setData("booked_type", null)
    }
    if (step.id === 3) {
      //Reset booked_date field as it may be unavailable
      setData("booked_date", null)
    }
    if (step.id === 4) {
      //Reset booked_time field as it may be unavailable
      setData("booked_time", null)
    }
    prevStep()
    
    document.querySelector('.mainLayout').scrollTop = 0;
  }

  const {
    watch,
    handleSubmit,
    formState: { isValid, errors },
  } = methods

  /*console.log("QS WATCH", watch())*/

  return (
    <div className="flex min-h-full flex-col justify-between">
      <StepLayout
        question={step.question}
        image={step.image}
        progress={step.progress}
      >
        <form>
          {step?.fields?.map((field, i) => {
            const Field = FIELDS?.[field?.field_type]

            return Field ? (
              <Field key={i} field={field} methods={methods} />
            ) : null
          })}
        </form>
      </StepLayout>

      <div className="mx-auto inline-flex items-center py-10 gap-4">
        <Button
          displayType={{ value: "button_tertiary" }}
          iconPosition={{ value: "left" }}
          onClick={handlePrev}
        >
          Zurück
        </Button>
        <Button
          displayType={{ value: "button_primary" }}
          iconPosition={{ value: "right" }}
          onClick={handleSubmit(handleNext)}
          disabled={!isValid}
        >
          Weiter
        </Button>
      </div>
    </div>
  )
}

export default QuestionStep
